import { FilterDefinition, Operators } from "@monolith-forensics/monolith-ui";
import TraceAccountsAPI from "./traceAccounts.api";
import { GetTraceAccountsResult } from "./traceAccounts.types";
import { useMemo } from "react";

export const useTraceAccountFilterDefinition = ({
  query,
}: {
  query: {
    case_id: string | number;
  };
}) => {
  const case_id = query.case_id.toString();

  const filterDef: FilterDefinition = useMemo(() => {
    return {
      label: "Account",
      pluralLabel: "Accounts",
      dataField: "trace_account_uuid",
      inputType: "multiselect",
      operators: [Operators.In, Operators.NIn],
      query: {
        initialPageParam: 1,
        cacheKey: ({ search }) =>
          JSON.stringify(
            TraceAccountsAPI.queryKeys.infiniteList({ case_id, pageSize: 1000 })
          ),
        loadPage: async ({ pageParam, search }) => {
          const page = await TraceAccountsAPI.get({
            pageSize: 1000,
            case_id,
          });

          return {
            items: (page as GetTraceAccountsResult).data.map((account) => ({
              label: account.name,
              value: account.uuid.toString(),
              data: account,
            })),
            nextPageParam: null, // No pagination for trace accounts, so we return null for nextPageParam
          };
        },
      },
    };
  }, [case_id]);

  return filterDef;
};
